export const extensionRoutes = [  {
    path: 'extensions/alerts',
    loadChildren: () => import('./extensions/alert-extension/routes'),
  },
  {
    path: 'extensions/new',
    loadChildren: () => import('./extensions/alert-extension/routes'),
  },
  {
    path: 'extensions/edit',
    loadChildren: () => import('./extensions/alert-extension/routes'),
  },
  {
    path: 'extensions/banners',
    loadChildren: () => import('./extensions/banner-extension/routes'),
  },
  {
    path: 'extensions/static',
    loadChildren: () => import('./extensions/static-extension/routes'),
  },
  {
    path: 'extensions/static-class',
    loadChildren: () => import('./extensions/static-extension/classes.routes'),
  },
  {
    path: 'extensions/default-product-information',
    loadChildren: () => import('./extensions/product-specs-ui/routes'),
  },
  {
    path: 'extensions/mandatory-product-notices',
    loadChildren: () => import('./extensions/product-specs-ui/default-product-description.routes'),
  },
  {
    path: 'extensions/mandatory-product-notice-translations',
    loadChildren: () => import('./extensions/product-specs-ui/default-product-description-translation.routes'),
  },
  {
    path: 'extensions/purchase-request',
    loadChildren: () => import('./extensions/request-purchase-extension/purchase-request-routes'),
  },
  {
    path: 'extensions/purchase-needed',
    loadChildren: () => import('./extensions/request-purchase-extension/purchase-needed-routes'),
  },
  {
    path: 'extensions/clubs',
    loadChildren: () => import('./extensions/fan-club-extension/routes'),
  },
  {
    path: 'extensions/links',
    loadChildren: () => import('./extensions/fan-club-extension/link.routes'),
  },
  {
    path: 'extensions/event',
    loadChildren: () => import('./extensions/fan-club-extension/event.routes'),
  },
  {
    path: 'extensions/event-email-templates',
    loadChildren: () => import('./extensions/fan-club-extension/event-email-template.routes'),
  },
  {
    path: 'extensions/cus',
    loadChildren: () => import('./extensions/fan-club-extension/cus.routes'),
  },
  {
    path: 'extensions/fan-club-edit-request',
    loadChildren: () => import('./extensions/fan-club-extension/edit-request-routes'),
  },
  {
    path: 'extensions/event-consent-content',
    loadChildren: () => import('./extensions/fan-club-extension/event-consent-content-routes'),
  },
  {
    path: 'extensions/settings',
    loadChildren: () => import('./extensions/custom-admin-ui/settings.routes'),
  },
  {
    path: 'extensions/ui-customer',
    loadChildren: () => import('./extensions/custom-admin-ui/routes'),
  },
  {
    path: 'extensions/ui-cooperate',
    loadChildren: () => import('./extensions/custom-admin-ui/cooperate-routes'),
  },
  {
    path: 'extensions/create-cooperate',
    loadChildren: () => import('./extensions/custom-admin-ui/create-cooperate-route'),
  },
  {
    path: 'extensions/free-gift',
    loadChildren: () => import('./extensions/custom-admin-ui/free-gifts-routes'),
  },
  {
    path: 'catalog',
    loadChildren: () => import('./extensions/custom-admin-ui/products.routes'),
  },
  {
    path: 'orders',
    loadChildren: () => import('./extensions/custom-admin-ui/order.routes'),
  },
  {
    path: 'marketing',
    loadChildren: () => import('./extensions/custom-admin-ui/promotion.routes'),
  },
  {
    path: 'settings',
    loadChildren: () => import('./extensions/custom-admin-ui/settings.routes'),
  },
  {
    path: 'extensions/qa',
    loadChildren: () => import('./extensions/question-post-extension/routes'),
  },
  {
    path: 'extensions/user-level',
    loadChildren: () => import('./extensions/user-level-extension/routes'),
  },
  {
    path: 'extensions/ware-house',
    loadChildren: () => import('./extensions/ware-house-extension/routes'),
  },
  {
    path: 'extensions/wh-product',
    loadChildren: () => import('./extensions/ware-house-extension/wh-product.routes'),
  },
  {
    path: 'extensions/refund',
    loadChildren: () => import('./extensions/refund-extension/routes'),
  },
  {
    path: 'extensions/inbounding',
    loadChildren: () => import('./extensions/inbounding-ui/inbounding.routes'),
  },
  {
    path: 'extensions/inbound-request',
    loadChildren: () => import('./extensions/inbounding-ui/inbound-request.routes'),
  },
  {
    path: 'extensions/inbound-complete',
    loadChildren: () => import('./extensions/inbounding-ui/inbound-complete.routes'),
  },
  {
    path: 'extensions/shippable',
    loadChildren: () => import('./extensions/shippable-extension/shippable.routes'),
  },
  {
    path: 'extensions/shippable-approve',
    loadChildren: () => import('./extensions/shippable-extension/shippable-approve.routes'),
  },
  {
    path: 'extensions/shipping-fee',
    loadChildren: () => import('./extensions/shipping-calculation-extension/routes'),
  },
  {
    path: 'extensions/split-order-rules',
    loadChildren: () => import('./extensions/shipping-calculation-extension/split-order-rules.routes'),
  },
  {
    path: 'extensions/artists',
    loadChildren: () => import('./extensions/artist-extension/artist.routes'),
  },
  {
    path: 'extensions/retailer',
    loadChildren: () => import('./extensions/retail-extension/routes'),
  },
  {
    path: 'extensions/product-type',
    loadChildren: () => import('./extensions/product-type-extension/routes'),
  },
  {
    path: 'extensions/request-cronjob',
    loadChildren: () => import('./extensions/purchase-cron-job-extension/routes'),
  },
  {
    path: 'extensions/history',
    loadChildren: () => import('./extensions/history-extension/routes'),
  },
  {
    path: 'extensions/audit-requests',
    loadChildren: () => import('./extensions/audit-request-extension/routes'),
  },
  {
    path: 'extensions/email-templates',
    loadChildren: () => import('./extensions/email-ui/routes'),
  },
  {
    path: 'extensions/email-history',
    loadChildren: () => import('./extensions/email-ui/history.routes'),
  },
  {
    path: 'extensions/supplier',
    loadChildren: () => import('./extensions/supplier-extension/routes'),
  },
  {
    path: 'extensions/package-waiting',
    loadChildren: () => import('./extensions/package-ui/package-waiting.routes'),
  },
  {
    path: 'extensions/package-pushed',
    loadChildren: () => import('./extensions/package-ui/package-pushed.routes'),
  },
  {
    path: 'extensions/shipment-requested',
    loadChildren: () => import('./extensions/package-ui/shipment-requested.routes'),
  },
  {
    path: 'extensions/shipment-completed',
    loadChildren: () => import('./extensions/package-ui/shipment-completed.routes'),
  },
  {
    path: 'extensions/need-to-ship',
    loadChildren: () => import('./extensions/need-to-ship-extension/routes'),
  },
  {
    path: 'extensions/package-reviews',
    loadChildren: () => import('./extensions/package-review-ui/routes'),
  },
  {
    path: 'extensions/country-price-exchange',
    loadChildren: () => import('./extensions/country-price-exchange-ui/routes'),
  },
  {
    path: 'settings',
    loadChildren: () => import('./extensions/country-price-exchange-ui/channel.routes'),
  },
  {
    path: 'extensions/notice',
    loadChildren: () => import('./extensions/notice-ui/routes'),
  },
  {
    path: 'push-template',
    loadChildren: () => import('./extensions/noti-ui/template.routes'),
  },
  {
    path: 'push-notifications',
    loadChildren: () => import('./extensions/noti-ui/routes'),
  },
  {
    path: 'extensions/tickets',
    loadChildren: () => import('./extensions/ticket-ui/routes'),
  },
  {
    path: 'extensions/tickets-bulletin',
    loadChildren: () => import('./extensions/ticket-ui/bulletin.routes'),
  },
  {
    path: 'extensions/service-fee',
    loadChildren: () => import('./extensions/service-fee-ui/routes'),
  },
  {
    path: 'extensions/album-rank',
    loadChildren: () => import('./extensions/best-album-ui/routes'),
  },
  {
    path: 'guidance',
    loadChildren: () => import('./extensions/guidance-ui/routes'),
  },
  {
    path: 'extensions/sms-templates',
    loadChildren: () => import('./extensions/sms-ui/routes'),
  },
  {
    path: 'extensions/sms-history',
    loadChildren: () => import('./extensions/sms-ui/history.routes'),
  },
  {
    path: 'extensions/event-planning',
    loadChildren: () => import('./extensions/event-planning-ui/routes'),
  },
  {
    path: 'remote-config',
    loadChildren: () => import('./extensions/remote-config-ui/routes'),
  },
  {
    path: 'country-shipping-fee',
    loadChildren: () => import('./extensions/country-based-shipping-method-ui/routes'),
  },
  {
    path: 'extensions/sales',
    loadChildren: () => import('./extensions/sales-ui/routes'),
  },
  {
    path: 'extensions/cooperate-discount',
    loadChildren: () => import('./extensions/cooperate-discount-ui/routes'),
  },
  {
    path: 'extensions/logistics-trajectory',
    loadChildren: () => import('./extensions/logistics-trajectory-ui/routes'),
  },
  {
    path: 'extensions/queue-settings',
    loadChildren: () => import('./extensions/queue-settings-ui/routes'),
  }];
